// Reserved-height skeletons. Match the dimensions of their loaded counterparts
// so the page doesn't shift when real data arrives.

const PULSE = "animate-pulse bg-stone-200 dark:bg-zinc-800";

function Bar({ w, h = 12, className = "" }: { w: string; h?: number; className?: string }) {
  return (
    <div
      className={`${PULSE} rounded ${className}`}
      style={{ width: w, height: h }}
    />
  );
}

export function PostCardSkeleton() {
  return (
    <div className="flex bg-white dark:bg-zinc-900 rounded-2xl border border-stone-200/60 dark:border-zinc-800/60 overflow-hidden h-[180px]">
      {/* Media slot */}
      <div className={`${PULSE} w-48 flex-shrink-0`} />
      {/* Content slot */}
      <div className="flex-1 p-4 flex flex-col gap-3 min-w-0">
        <div className="flex items-center justify-between">
          <Bar w="60%" />
          <Bar w="60px" h={20} />
        </div>
        <Bar w="100%" />
        <Bar w="90%" />
        <Bar w="40%" />
        <div className="mt-auto flex gap-2">
          <Bar w="80px" h={24} />
          <Bar w="80px" h={24} />
          <Bar w="80px" h={24} />
        </div>
      </div>
    </div>
  );
}

export function PostListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <PostCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[0, 1, 2].map((i) => (
          <div key={i} className="bg-white dark:bg-zinc-900 rounded-2xl border border-stone-200/60 dark:border-zinc-800/60 p-5 h-[120px] flex flex-col gap-3">
            <Bar w="50%" />
            <Bar w="40%" h={28} />
            <Bar w="30%" />
          </div>
        ))}
      </div>
      <div className="bg-white dark:bg-zinc-900 rounded-2xl border border-stone-200/60 dark:border-zinc-800/60 p-5">
        <Bar w="20%" h={16} className="mb-4" />
        <PostListSkeleton count={3} />
      </div>
    </div>
  );
}

export function InboxRowSkeleton() {
  return (
    <div className="flex items-start gap-3 p-4 bg-white dark:bg-zinc-900 rounded-2xl border border-stone-200/60 dark:border-zinc-800/60 h-[88px]">
      <div className={`${PULSE} w-10 h-10 rounded-full flex-shrink-0`} />
      <div className="flex-1 flex flex-col gap-2 min-w-0">
        <div className="flex items-center justify-between">
          <Bar w="30%" />
          <Bar w="60px" />
        </div>
        <Bar w="90%" />
        <Bar w="60%" />
      </div>
    </div>
  );
}

export function InboxListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <InboxRowSkeleton key={i} />
      ))}
    </div>
  );
}

export function AccountChipSkeleton() {
  return <div className={`${PULSE} h-9 w-32 rounded-xl`} />;
}

export function AccountChipListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="flex flex-wrap gap-2">
      {Array.from({ length: count }).map((_, i) => (
        <AccountChipSkeleton key={i} />
      ))}
    </div>
  );
}
